import React from "react";
import {
  Layout,
  Container,
  TitleContainer,
} from "../../style/Home/HomeBanner.module.js";

export const HomeBanner = () => {
  return (
    <Layout>
      <Container>
        <TitleContainer>
          <div>내가 찾던</div>
          <div>면세점 위스키 가격이 한곳에!</div>
        </TitleContainer>
      </Container>
    </Layout>
  );
};
